import React, { Component } from 'react';
import axios from 'axios';


import {
  NavLink,
  Redirect
} from 'react-router-dom';


class SunumEligard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      date: '',
      sunum01: [],
      sunum02: [],
      sunum03: [],
      sunum04: [],
      sunum05: [],
      sunum06: [],
      sunum07: []
    }
  }

  componentDidMount() {
  
  const sonuc19 = 19;
  const sonuc24 = 24;
  const sonuc11 = 11;

    var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
  	const postId = location.pathname.split("/")[2];
  	//console.log(postId);
  
        var url01 = 'https://api.recordatifocus.com/eligard-sonuc-01/' + postId;
        fetch(url01)
            .then(response01 => response01.json())
            .then(data01 => this.setState({
                sunum01: data01
            }));
        var url02 = 'https://api.recordatifocus.com/eligard-sonuc-02/' + postId;
        fetch(url02)
            .then(response02 => response02.json())
            .then(data02 => this.setState({
                sunum02: data02
            }));
        var url03 = 'https://api.recordatifocus.com/eligard-sonuc-03/' + postId;
        fetch(url03)
            .then(response03 => response03.json())
            .then(data03 => this.setState({
                sunum03: data03
            }));
        var url04 = 'https://api.recordatifocus.com/eligard-sonuc-04/' + postId;
        fetch(url04)
            .then(response04 => response04.json())
            .then(data04 => this.setState({
                sunum04: data04
            }));
        var url05 = 'https://api.recordatifocus.com/eligard-sonuc-05/' + postId;
        fetch(url05)
            .then(response05 => response05.json())
            .then(data05 => this.setState({
                sunum05: data05
            }));
        var url06 = 'https://api.recordatifocus.com/eligard-sonuc-06/' + postId;
        fetch(url06)
            .then(response06 => response06.json())
            .then(data06 => this.setState({
                sunum06: data06
            }));
        var url07 = 'https://api.recordatifocus.com/eligard-sonuc-07/' + postId;
        fetch(url07)
            .then(response07 => response07.json())
            .then(data07 => this.setState({
                sunum07: data07
            }));



        }


        render() {
	// soru 01
                const {
                    sunum01
                } = this.state;
                let outputData01 = sunum01.map((item) => {
                    return {
                        cevap01: parseInt(item.cevap),
                    };
                });
                const result01 = Object.values(outputData01).reduce(
                    (r, {
                        cevap01
                    }) => r + cevap01,
                    0
                );
                const longeur01 = sunum01.length;
                let sonuc01 = 100 - (result01 * 100) / longeur01;
                console.log("Soru10 yanlis orani:", sonuc01);
	  // soru 02
                  const {
                    sunum02
                } = this.state;
                let outputData02 = sunum02.map((item) => {
                    return {
                        cevap02: parseInt(item.cevap),
                    };
                });
                const result02 = Object.values(outputData02).reduce(
                    (r, {
                        cevap02
                    }) => r + cevap02,
                    0
                );
                const longeur02 = sunum02.length;
                let sonuc02 = 100 - (result02 * 100) / longeur02;
                console.log("Soru02 yanlis orani:", sonuc02);
	  // soru 03
                  const {
                    sunum03
                } = this.state;
                let outputData03 = sunum03.map((item) => {
                    return {
                        cevap03: parseInt(item.cevap),
                    };
                });
                const result03 = Object.values(outputData03).reduce(
                    (r, {
                        cevap03
                    }) => r + cevap03,
                    0
                );
                const longeur03 = sunum03.length;
                let sonuc03 = 100 - (result03 * 100) / longeur03;
                console.log("Soru03 yanlis orani:", sonuc03);

	  // soru 04
                  const {
                    sunum04
                } = this.state;
                let outputData04 = sunum04.map((item) => {
                    return {
                        cevap04: parseInt(item.cevap),
                    };
                });
                const result04 = Object.values(outputData04).reduce(
                    (r, {
                        cevap04
                    }) => r + cevap04,
                    0
                );
                const longeur04 = sunum04.length;
                let sonuc04 = 100 - (result04 * 100) / longeur04;
                console.log("Soru04 yanlis orani:", sonuc04);

	  // soru 05
                  const {
                    sunum05
                } = this.state;
                let outputData05 = sunum05.map((item) => {
                    return {
                        cevap05: parseInt(item.cevap),
                    };
                });
                const result05 = Object.values(outputData05).reduce(
                    (r, {
                        cevap05
                    }) => r + cevap05,
                    0
                );
                const longeur05 = sunum05.length;
                let sonuc05 = 100 - (result05 * 100) / longeur05;
                console.log("Soru05 yanlis orani:", sonuc05);

	  // soru 06
                  const {
                    sunum06
                } = this.state;
                let outputData06 = sunum06.map((item) => {
                    return {
                        cevap06: parseInt(item.cevap),
                    };
                });
                const result06 = Object.values(outputData06).reduce(
                    (r, {
                        cevap06
                    }) => r + cevap06,
                    0
                );
                const longeur06 = sunum06.length;
                let sonuc06 = 100 - (result06 * 100) / longeur06;
                console.log("Soru06 yanlis orani:", sonuc06);

	  // soru 07
                  const {
                    sunum07
                } = this.state;
                let outputData07 = sunum07.map((item) => {
                    return {
                        cevap07: parseInt(item.cevap),
                    };
                });
                const result07 = Object.values(outputData07).reduce(
                    (r, {
                        cevap07
                    }) => r + cevap07,
                    0
                );
                const longeur07 = sunum07.length;
                let sonuc07 = 100 - (result07 * 100) / longeur07;
                console.log("Soru07 yanlis orani:", sonuc07);
 
  
  
      var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {

    return (
    
    
    
      <div className="row pt-5">
          <div className="col-md-6">
              <div className="list-group">
                  <div className="list-group-item list-group-item-action list-group-item-success">Sunum Sorular Yanlış Oranı</div>
              </div>
              <div className="list-group mb-3">
                  <br />
                  <div className="list-group-item list-group-item-action">
                      Soru 1 : {sonuc01.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 2 : {sonuc02.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 3 : {sonuc03.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 4 : {sonuc04.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 5 : {sonuc05.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 6 : {sonuc06.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 7 : {sonuc07.toFixed(2)}
                  </div>
              </div>
          </div>


          <div className="col-md-6">
              <div className="list-group">
                  <div className="list-group-item list-group-item-action list-group-item-success mb-1">ELİGARD Sorular ve Cevaplar</div>
              </div>
              <div className="list-group mb-3">
              
                  <div className="p-2">


                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">1. </span>
                                    <span class="fieldset-legend">Eligard 22.5 mg ve 45 mg ile gerçekleşen tedavi protokolünde benzer PSA seviyelerine ulaşılmaktadır.</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">Doğru</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Yanlış</div>
                                    </div>
                                </div>
                            </div>




                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">2. </span>
                                    <span class="fieldset-legend">Eligard 22.5 mg ve 45 mg tedavileriyle 50-20 ng/dL altına ulaşan hasta yüzdeleri sırasıyla hangi seçenekte doğru verilmiştir?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">100-100; 94-96</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">90-90; 50-55</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">85-85; 60-62</div>
                                    </div>
                                </div>
                            </div>




                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">3. </span>
                                    <span class="fieldset-legend">Eligard 22.5 mg ve 45 mg tedavileriyle 20 ng/dL’nin altındaki nadir testosteron seviyeleri hastaların yüzde kaçında gözlemlenmiştir?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">99</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">90</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">80</div>
                                    </div>
                                </div>
                            </div>



                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">4. </span>
                                    <span class="fieldset-legend">ELIGARD® 22.5 mg ve 45 mg ile yapılan takip çalışmasında, 6 ay boyunca ≤20 ng/dL testosteron seviyeleri hastaların en az yüzde kaçında sağlanmıştır?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">80</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">91</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">72</div>
                                    </div>
                                </div>
                            </div>



                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">5. </span>
                                    <span class="fieldset-legend">Farklı yaş (70, 70-80, ≥80) ve farklı kilolarda (80, 80-90, ≥90 kg) bulunan hasta gruplarında ELIGARD® 22.5 mg ve 45 mg ile gerçekleştirilen çalışmada testosteron seviyeleri kaçıncı hafta itibariyle EAU kılavuzunun daha uygun bir kastrasyon seviyesi ( 20 ng/dL ) olarak tanımladığı seviyenin altına ulaşmıştır?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">4. Hafta</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">5. Hafta</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">6. Hafta</div>
                                    </div>
                                </div>
                            </div>
						<div class="bg-white pb-3 pt-4 px-4 rounded-3 my-5 border-eligard js-form-item js-form-type-processed-text form-type-processed-text js-form-item- form-item- form-no-label" id="edit-metin-1">
                    <p><span>EAU kılavuzunda, kastrasyonun elde edilememesi ya da korunamaması durumunda, bir başka agoniste veya antagoniste geçilmesinin ya da orşiektominin düşünülmesi gerektiği önerilmektedir.</span></p>
                      </div>

                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">6. </span>
                                    <span class="fieldset-legend"> Goserelin asetat tedavisi altındayken medyan testosteron değeri 72.3 ng/dL seviyesinde olan hasta grubunda, ELIGARD® 45mg tedavisine geçişi takiben testosteron değeri medyan kaç ng/dL’ye düşmüştür?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">18</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">28</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">38</div>
                                    </div>
                                </div>
                            </div>
					<div class="bg-white pb-3 pt-4 px-4 rounded-3 my-5 border-eligard js-form-item js-form-type-processed-text form-type-processed-text js-form-item- form-item- form-no-label" id="edit-text-2">
                    <p>İlk kez ELIGARD® 22.5 mg ve 45 mg tedavileri alan hasta grubunda medyan PSA seviyesi 150 ng/mL iken, tedavi ile PSA değeri medyan 0,4 ng/mL’ye düşmüştür.</p>
                      </div>

                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">7. </span>
                                    <span class="fieldset-legend">Mikroküre löprolid asetat tedavisi altındayken medyan PSA değeri 6.9 ng/mL olan hasta grubunda, ELIGARD® 22.5 mg ve 45 mg tedavilerine geçişi takiben PSA değerleri kaç ng/mL’ye düşmüştür?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">0.7</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">0.3</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">0.6</div>
                                    </div>
                                </div>
                            </div>









                  </div>
              
              </div>

          
          </div>







      </div>




    );
    } else {
        return (
          <div className="row top-buffer">
        	<Redirect to="/user/login" />
          </div>
        );
    }



  }
}

export default SunumEligard



// WEBPACK FOOTER //
// src/components/sunum.jsx